import React, { memo, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './Textarea.css';
import arePropsEqual from '../../../helpers/arePropsEqual';
import { bem } from '../../../helpers/styles';
import useFocusOnInit from '../../../hooks/useFocusOnInit';

function TextareaComponent({
  rows = 2,
  onChange = () => null,
  onBlur,
  onFocus = () => null,
  value,
  error,
  disabled,
  isFocusOnInit,
  placeholder,
  required = false,
}) {
  const ref = useRef();

  const props = {
    onChange: useCallback((e) => onChange(e), [onChange]),
    rows,
    disabled,
  };

  useFocusOnInit(ref, isFocusOnInit, onFocus);

  return (
    <textarea
      ref={ref}
      className={bem(styles, 'Textarea', { error })}
      {...props}
      onBlur={onBlur}
      value={value}
      onFocus={onFocus}
      placeholder={placeholder}
    />
  );
}

TextareaComponent.propTypes = {
  isFocusOnInit: PropTypes.bool,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.any,
  disabled: PropTypes.bool,
};

const Textarea = memo(TextareaComponent, (oldProps, newProps) => {
  return arePropsEqual(oldProps, newProps);
});

export default Textarea;
